import React from "react";
import "./ScorecardSummaryTableSticky.css"; // Import the CSS file

function ScorecardSummaryRowPlayerNameCell({ player }) {
  return (
    <td
      // className="align-middle sticky"
      className="sticky"
      style={{
        //   width: "30px",
        //   // tableLayout: "auto",
        // border: "2px solid #2D083F",
        color: "#2D083F",
        //   // position: "sticky",
        //   // left: 0,
        //   background: "#FFFFFF",
        whiteSpace: "normal",
        fontWeight: "bold",
        fontStyle: "italic",
      }}
    >
      {player}
    </td>
  );
}

export default ScorecardSummaryRowPlayerNameCell;
